import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  status: "true",
};

export const NavSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    open: (state) => {
      state.status = false
    },
    close: (state) => {
      state.status = true  
    },
  },
});

// export const { increment, decrement, addAmount } = counterSlice.actions;
export const { open, close } = NavSlice.actions
// export const flag = (state) => state.NavReducer.status
export default NavSlice.reducer;
